import React from "react";
import { useColorMode } from "@chakra-ui/color-mode";
import { IconButton } from "@chakra-ui/button";
import { Flex, Spacer } from "@chakra-ui/layout";
import { FaSun, FaMoon, FaGithub, FaLinkedin } from "react-icons/fa";

export const Navbar = () => {
	const { colorMode, toggleColorMode } = useColorMode();
	const isDark = colorMode === "dark";

	return (
		<Flex w="92%" mt={"15px"}>
			<IconButton
				icon={<FaLinkedin />}
				isRound="true"
				onClick={() => {
					window.open("https://www.linkedin.com/in/abhijitaher/", "_blank");
				}}
			></IconButton>
			<IconButton
				ml={3}
				icon={<FaGithub />}
				isRound="true"
				onClick={() => {
					window.open("https://github.com/AbhijitAher", "_blank");
				}}
			></IconButton>
			<Spacer />
			<IconButton
				icon={isDark ? <FaSun /> : <FaMoon />}
				isRound="true"
				onClick={toggleColorMode}
			></IconButton>
		</Flex>
	);
};
